import { calculateDaysBetweenDates } from "../utilities/DateUtil";
import { Paper, Text, useMantineTheme } from "@mantine/core";

interface DaysUntilAudioDeletionProps {
  dateOfCreation: Date;
}

export const DaysUntilAudioDeletion = ({
  dateOfCreation,
}: DaysUntilAudioDeletionProps) => {
  const today = new Date();
  const daysPassed = calculateDaysBetweenDates(today, dateOfCreation);
  const daysUntilAudioDeletion = 45 - daysPassed;
  const daysUntilTranscriptDeletion = 180 - daysPassed;
  let audioStyle;
  let transcriptStyle;

  const theme = useMantineTheme();

  const expiredStyle = {
    backgroundColor: theme.colors.gray[3],
    color: theme.colors.gray[7],
  };

  const criticalStyle = {
    backgroundColor: theme.colors.red[1],
    color: theme.colors.red[6],
  };

  const warningStyle = {
    backgroundColor: theme.colors.yellow[0],
    color: theme.colors.orange[6],
  };

  const noWarningStyle = {
    backgroundColor: theme.colors.green[0],
    color: theme.colors.green[6],
  };

  if (daysPassed >= 45) {
    audioStyle = expiredStyle;
  } else if (daysPassed > 40) {
    audioStyle = criticalStyle;
  } else if (daysPassed > 25) {
    audioStyle = warningStyle;
  } else {
    audioStyle = noWarningStyle;
  }

  if (daysPassed >= 180) {
    transcriptStyle = expiredStyle;
  } else if (daysPassed > 160) {
    transcriptStyle = criticalStyle;
  } else if (daysPassed > 120) {
    transcriptStyle = warningStyle;
  } else {
    transcriptStyle = noWarningStyle;
  }

  if (daysUntilAudioDeletion < 0) {
    return (
      <>
        <Paper p="xs" shadow="xs" style={audioStyle}>
          <Text size="sm" style={audioStyle}>
            Audio deleted
          </Text>
        </Paper>
        <Paper p="xs" shadow="xs" style={transcriptStyle}>
          <Text size="sm" style={transcriptStyle}>
            {daysUntilTranscriptDeletion < 0
              ? "Transcription deleted"
              : `${daysUntilTranscriptDeletion} days until transcription deletion`}
          </Text>
        </Paper>
      </>
    );
  } else {
    return (
      <Paper p="xs" shadow="xs" style={audioStyle}>
        <Text
          size="sm"
          style={audioStyle}
        >{`${daysUntilAudioDeletion} days until audio deletion`}</Text>
      </Paper>
    );
  }
};
